export function LoyaltyPointsRouter($stateProvider) {
  $stateProvider
    .state('app.ops-support-loyalty-points', {
      url: '/ops-support/loyalty-points',
      template: '<app-loyalty-points></app-loyalty-points>',
    })
}



// WEBPACK FOOTER //
// ./src/app/ops-support/loyalty-points/loyalty-points.router.js